<!--首页-->
<template>
  <div class="home-box cr">
    <div class="my-works bbox">
      <div class="select-box" :style="{ backgroundColor: theme.layout1 }">
        <!--        <div class="flex ac jb">-->
        <!--          <div class="flex ac">-->
        <!--            <p class="bold mr15" :style="{ color: multiIndex==0 ? theme.worksColor2 : theme.worksColor22 }"-->
        <!--               @click="handleTitle(0)">我的作品<span-->
        <!--              >·{{worksTotal}}</span></p>-->
        <!--            <p class="bold mr15" :style="{ color: multiIndex==1 ? theme.worksColor2 : theme.worksColor22 }"-->
        <!--               @click="handleTitle(1)">多场景作品(Beta)<span-->
        <!--            >·{{dcVideototal}}</span></p>-->
        <!--            <p class="bold mr15" :style="{ color: multiIndex==2 ? theme.worksColor2 : theme.worksColor22 }"-->
        <!--               @click="handleTitle(2)">多场景音频(Beta)<span-->
        <!--            >·{{dcVoicetotal}}</span></p>-->
        <!--          </div>-->
        <!--          <div class="flex ac">-->
        <!--            <el-select v-model="selectObj.status" placeholder="请选择" @change="select">-->
        <!--              <el-option-->
        <!--                v-for="item in options"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value">-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--            <el-input-->
        <!--              style="margin-left: 10px"-->
        <!--              placeholder="名称搜索"-->
        <!--              v-model="selectObj.name"-->
        <!--            >-->
        <!--              <el-button slot="append" icon="el-icon-search" @click="select()"></el-button>-->
        <!--            </el-input>-->
        <!--            <div class="dz-btn-box cr" @click="handleAdd">+创作作品</div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="one-grade" :style="{ borderBottomColor: theme.layout8, borderLeftColor: theme.layout8}">
          <div class="flex ac">

            <div class="mr30" :style="{ color: oneGradeIndex == 0 ? theme.worksColor2 : theme.worksColor22 }"
                 @click="handleTitle(0)">视频作品
            </div>
            <div :style="{ color: oneGradeIndex == 1? theme.worksColor2 : theme.worksColor22 }" @click="handleTitle(1)">
              多场景作品
            </div>
          </div>
        </div>
        <div class="two-grade" :style="{ borderLeftColor: theme.layout8}" v-if="oneGradeIndex==0">
          <div class="flex ac">
            <div class="every-fl-box" :style="{ color: twoGradeIndex==0? theme.useColor4 : theme.homeColor4, backgroundColor: twoGradeIndex==0 ? theme.useColor3 : theme.useColor1}" @click="handleTitle2(0)">
              数字人视频·{{worksTotal}}
            </div>
            <div class="every-fl-box" :style="{ color: twoGradeIndex==1? theme.useColor4 : theme.homeColor4, backgroundColor: twoGradeIndex==1 ? theme.useColor3 : theme.useColor1}" @click="handleTitle2(1)">
              宠物视频·{{petTotal}}
            </div>
            <div class="every-fl-box" :style="{ color: twoGradeIndex==2? theme.useColor4 : theme.homeColor4, backgroundColor: twoGradeIndex==2 ? theme.useColor3 : theme.useColor1}" @click="handleTitle2(2)">
              照片说话·{{photoTotal}}
            </div>
            <div class="every-fl-box" :style="{ color: twoGradeIndex==3? theme.useColor4 : theme.homeColor4, backgroundColor: twoGradeIndex==3 ? theme.useColor3 : theme.useColor1}" @click="handleTitle2(3)">
              翻译视频·{{seaTotal}}
            </div>
          </div>
        </div>
        <div class="two-grade" v-if="oneGradeIndex==1">
          <div class="flex ac">
            <div class="every-fl-box" :style="{ color: twoGradeIndex==0? theme.useColor4 : theme.homeColor4, backgroundColor: twoGradeIndex==0 ? theme.useColor3 : theme.useColor1}" @click="handleTitle2(0)">
              多场景视频·{{dcVideototal}}
            </div>
            <div class="every-fl-box" :style="{ color: twoGradeIndex==1? theme.useColor4 : theme.homeColor4, backgroundColor: twoGradeIndex==1 ? theme.useColor3 : theme.useColor1}" @click="handleTitle2(1)">
              多场景音频·{{dcVoicetotal}}
            </div>
          </div>
        </div>

        <div class="works-info-box">
          <div v-if="workList.length<=0" class="no-fenshen-box">
            <img src="../assets/pcImages/4.1_Icon_1@2x.png" alt="no">
            <p>上传视频, 快速创作作品</p>
            <div class="ks-dingzhi cr" @click="handleAdd">+创作作品</div>
          </div>
          <div v-else>
            <div class="flex ac fw" v-if="oneGradeIndex==1&&twoGradeIndex==1">
              <div class="every-voice flex ac" v-for="(item,index) in workList" :key="index"
                   :style="{borderColor:theme.voiceColor1,backgroundColor: theme.voiceColor2}">
                <div class="card-img" @mouseover="handleMouse(item)" @mouseleave="handleMouseOut"
                     @click="handlePlay2(item)">
                  <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="">
                  <div class="hover-box icon-player playing" v-if="mouseState && hoverId==item.id">
                    <div class="play-pause-btn">
                      <i class="el-icon-video-play" v-if="palyState==1 || clickId!=item.id"
                         style="color: #ffffff;font-size: 25px"></i>
                      <i class="el-icon-video-pause" v-if="palyState==2" style="color: #ffffff;font-size: 25px"></i>
                      <img class="playing-box" v-if="palyState==3 && clickId==item.id"
                           src="../assets/pcImages/voice-playing.gif">
                    </div>
                  </div>
                </div>
                <div>
                  <p class="pp4" v-if="item.name" :style="{color: theme.voiceColor3}">{{item.name}}</p>
                  <p class="pp5" :style="{color: theme.voiceColor4}">多场景声音作品</p>
                </div>
                <div class="handle-box">
                  <el-popover
                    placement="top"
                    width="120"
                    v-model="item.visible">
                    <div class="cr tc">
                      <el-button type="primary" size="mini" style="margin-bottom: 5px" @click="handleReName(item)">重命名
                      </el-button>
                      <el-button type="primary" size="mini" style="margin-bottom: 5px" @click="handleDown(item)">下载音频
                      </el-button>
                      <el-button type="warning" size="mini" @click="handleDelete(item)">删除
                      </el-button>
                    </div>
                    <template slot="reference">
                      <div>
                        <i class="el-icon-more" :style="{color: theme.voiceColor4}"></i>
                      </div>
                    </template>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="flex ac fw" v-else-if="oneGradeIndex==0&&twoGradeIndex==3">
              <div class="every-video bbox"
                   :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                   v-for="(item,index) in workList" :key="index" @click="handlePlay(item)">
                <div class="api-num2">
                  {{item.api_name}}
                </div>
                <div class="desc-box">
                  <div class="flex ac jb left-tt-box te">
                    <div>
                      <p class="text11 te">{{item.name}}</p>
                      <p class="text22">{{item.create_time}}</p>
                    </div>
                    <div v-if="item.status==3 || item.status==4" class="handle-box">
                      <el-popover
                        placement="top"
                        width="120"
                        trigger="hover"
                        v-model="item.visible">
                        <div class="cr tc">
                          <el-button v-if="item.status==3" type="primary" size="mini" style="margin-bottom: 5px"
                                     @click="downVideo(item)">下载
                          </el-button>
                          <el-button type="warning" size="mini" @click="handleDelete(item)">
                            删除
                          </el-button>
                        </div>
                        <template slot="reference">
                          <div>
                            <img class="handle-box-img" src="../assets/pcImages/6.1_Icon_2@2x.png" alt="">
                          </div>
                        </template>
                      </el-popover>
                    </div>
                  </div>
                </div>
                <div class="shengchenging" v-if="item.status==4">
                  <div class="desc-pp">
                    <p>生成失败，重新生成</p>
                  </div>
                </div>
                <div class="shengchenging" v-if="item.status!=3 &&  item.status!==4">
                  <div class="desc-pp">
                    <p>视频已提交云算力中心合成中</p>
                    <p>请稍后查看，可继续操作其它</p>
                  </div>
                  <img src="https://xcyq.oss-cn-qingdao.aliyuncs.com/weChatApp/loadingGif2.gif" alt="gif">
                </div>

              </div>
            </div>

            <div v-else class="flex ac fw ">
              <div class="every-video bbox "
                   :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                   v-for="(item,index) in workList" :key="index" @click="handlePlay(item)">
                <div class="api-num1" v-if="item.api_name&&item.api_key=='ou'||item.api_key=='gj'">
                  {{item.api_name}}
                </div>
                <div class="api-num2" v-else-if="item.api_name&&item.api_key=='df'">
                  {{item.api_name}}
                </div>
                <div class="api-num3" v-else-if="item.api_name&&item.api_key=='fy'">
                  {{item.api_name}}
                </div>
                <div class="api-num-other" v-else>
                  {{item.api_name}}
                </div>

                <div class="desc-box">
                  <div class="flex ac jb left-tt-box te">
                    <div>
                      <p class="text11 te">{{item.name}}</p>
                      <p class="text22">{{item.create_time}}</p>
                    </div>
                    <div v-if="item.status==3 || item.status==4" class="handle-box">
                      <el-popover
                        placement="top"
                        width="120"
                        trigger="hover"
                        v-model="item.visible">
                        <div class="cr tc">
                          <el-button v-if="item.status==3" type="primary" size="mini" style="margin-bottom: 5px"
                                     @click="downVideo(item)">下载
                          </el-button>
                          <el-button v-if="item.status==3 && twoGradeIndex!=3" type="primary" size="mini"
                                     style="margin-bottom: 5px" @click="handleReName(item)">重命名
                          </el-button>
                          <el-button type="warning" size="mini" @click="handleDelete(item)">
                            删除
                          </el-button>
                        </div>
                        <template slot="reference">
                          <div>
                            <img class="handle-box-img" src="../assets/pcImages/6.1_Icon_2@2x.png" alt="">
                          </div>
                        </template>
                      </el-popover>
                    </div>
                  </div>
                </div>
                <!--          v-if="item.status==2 || item.status==1"-->
                <div class="shengchenging" v-if="item.status!=3 && item.status!==4">
                  <div class="desc-pp" v-if="item.api_key=='ou'">
                    <p>排队训练中</p>
                    <p>对效果及训练时长不满意</p>
                    <p>可以选择更高等级通道训练</p>
                  </div>

                  <div class="desc-pp" v-else-if="item.api_key=='gj'">
                    <p>免费排队训练中</p>
                    <p>时间无法确定预测</p>
                    <p>可以选择更高等级通道训练</p>
                  </div>
                  <div class="desc-pp" v-else-if="item.api_key=='df'">
                    <p>极速训练中3~5分钟</p>
                    <p>如对生成效果不满意</p>
                    <p>可选择更高等级训练</p>
                  </div>
                  <div class="desc-pp" v-else-if="item.api_key=='fy'">
                    <p>深度训练中</p>
                    <p>6~10分钟请耐心等待</p>
                  </div>
                  <div class="desc-pp" v-else>
                    <p>正在为您训练中</p>
                    <p>请耐心等待</p>
                  </div>

                  <img src="https://xcyq.oss-cn-qingdao.aliyuncs.com/weChatApp/loadingGif2.gif" alt="gif">
                </div>

                <div class="shengchenging" v-if="item.status==4">
                  <div class="desc-pp">
                    <p>生成失败，重新生成</p>
                    <p>或选择更高等级训练</p>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>


    </div>

    <el-dialog
      :title="videoName"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleDialogClose"
    >
      <div class="dialog-video">
        <video ref="videoPlayer" style="width: 100%;height: 100%" controls="" autoplay="" :src="videoUrl"></video>
      </div>
    </el-dialog>
    <el-dialog
      title="重命名"
      :visible.sync="dialogVisible3"
      width="25%"
      top="35vh"
    >
      <el-input v-model="name" placeholder="请输入名字"/>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible3 = false">取 消</el-button>
    <el-button type="primary" @click="sumbitName">确 定</el-button>
  </span>
    </el-dialog>

    <el-dialog
      title="视频下载进度"
      :visible.sync="dialogVisible4"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="25%"
      top="35vh"
    >
      <div>
        <el-progress :percentage="progress"></el-progress>
      </div>
    </el-dialog>
    <audio
      style="width: 1px;height: 1px;opacity: 0;position: fixed;right: 0;bottom: 0"
      ref="audioPlayer"
      @ended="audioEnded"
      :src="audioSrc"
      controls></audio>
  </div>
</template>
<script>
  import {creditsLog, delWorks, getWorks, postWorks, getPhoto, getVideoTranslate, delVideoTranslate} from "../api/user";

  export default {
    name: '',
    computed: {
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    data() {
      return {
        options: [{
          value: '0',
          label: '全部'
        }, {
          value: '2',
          label: '生成中'
        }, {
          value: '3',
          label: '生成成功'
        }, {
          value: '4',
          label: '生成失败'
        }],
        value: '',
        input2: '',
        autoState: true,
        dcVideototal: null,
        dcVoicetotal: null,
        worksTotal: null,
        photoTotal: null,
        seaTotal: null,
        petTotal: null,
        workList: [],
        selectObj: {
          page: 1,
          limit: 9999,
          status: '',
          name: '',
          is_multi: '',
          only_audio: ''
        },
        hoverId: '',
        mouseState: false,
        clickId: false,
        palyState: 1,
        audioSrc: '',
        dialogVisible: false,
        dialogVisible3: false,
        dialogVisible4: false,
        videoName: '',
        videoUrl: '',
        myOneVoice: {},
        name: '',
        generate: '',
        pollingInterval: null,
        progress: 0,
        // 1是视频作品 2是多场景
        oneGradeIndex: 0,
        twoGradeIndex: 0,
        firstEntry: true
      }
    },
    created() {
      if (this.$route.query.type1 && !this.$route.query.type2) {
        this.oneGradeIndex = this.$route.query.type1
        this.handleTitle(this.$route.query.type1)
      } else if (this.$route.query.type1 && this.$route.query.type2) {
        this.oneGradeIndex = this.$route.query.type1
        this.twoGradeIndex = this.$route.query.type2
        this.handleTitle2(this.$route.query.type2)
      } else {
        this.getWorksList()
      }
      // 获取多场景的总条数
      this.getWorksTotal()
    },
    beforeDestroy() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
      // setTimeout(() => {
      //   if (this.generate > 0) {
      //     this.pollingInterval = setInterval(this.getWorksList, 10000);
      //   }
      // }, 1500)
      this.pollingInterval = setInterval(this.getWorksList, 15000);
    },
    methods: {
      handleAdd() {
        if (this.oneGradeIndex == 1) {
          this.$router.push('/multiples')
        }
        if (this.oneGradeIndex == 0) {
          if (this.twoGradeIndex == 0) {
            this.$router.push('/create')
          }
          if (this.twoGradeIndex == 1) {
            this.$router.push('/pet')
          }
          if (this.twoGradeIndex == 2) {
            this.$router.push('/store/imageSpeak')
          }
        }
      },
      handleMouse(item) {
        this.hoverId = item.id
      },
      handleMouseOut() {
        this.hoverId = ''
      },
      handleMouse(item) {
        this.mouseState = true
        this.hoverId = item.id
      },
      handleMouseOut() {
        if (this.palyState != 3) {
          this.mouseState = false
        }
      },
      handlePlay2(item) {
        this.mouseState = true
        this.clickId = item.id
        if (this.palyState == 1) {
          this.palyState = 3
          this.audioSrc = item.url
          this.$nextTick(() => {
            const audio = this.$refs.audioPlayer
            audio.load()
            audio.play()
          })
        } else if (this.palyState == 3) {
          this.palyState = 1
          this.$refs.audioPlayer.pause()
        }
      },
      audioEnded() {
        this.palyState = 1
      },
      select() {
        this.getWorksList()
      },
      getWorksTotal() {
        getWorks({
          page: 0,
          limit: 0,
          status: '',
          name: '',
          is_multi: '1',
          only_audio: '2'
        }).then(res => {
          this.dcVideototal = res.data.total
        })
        getWorks({page: 0, limit: 0, is_multi: 1, only_audio: 1}).then(res => {
          this.dcVoicetotal = res.data.total
        })
        getWorks({page: 0, limit: 0, is_multi: '', only_audio: ''}).then(res => {
          this.worksTotal = res.data.total
        })
        getWorks({page: 0, limit: 0, photo_type: '1'}).then(res => {
          this.photoTotal = res.data.total
        })
        // 宠物
        getWorks({page: 0, limit: 0, photo_type: '2'}).then(res => {
          this.petTotal = res.data.total
        })
        // 出海视频
        getVideoTranslate({page: 0, limit: 0}).then(res => {
          this.seaTotal = res.data.total
        })
      },
      getWorksList() {
        if (this.firstEntry) {
          this.loading = this.$loading({
            lock: true,
            text: '加载中,请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.6)'
          });
        }
        getWorks({...this.selectObj}).then(res => {
          this.generate = res.data.generate
          this.workList = res.data.list
          this.firstEntry = false
          this.loading.close()
          // console.log('this.workList',this.workList)
        })
      },
      // getVideoTranslateList() {
      //   this.workList = []
      //   getVideoTranslate({page: 0, limit: 0}).then(res => {
      //     this.workList = res.data.list
      //   })
      // },
      handleTitle(val) {
        this.oneGradeIndex = val
        this.twoGradeIndex = 0
        this.firstEntry = true
        if (val == 0) {
          this.workList = []
          this.selectObj.only_audio = ''
          this.selectObj.is_multi = ''
        }
        // 多场景视频
        if (val == 1) {
          if (this.twoGradeIndex == 0) {
            this.selectObj.only_audio = 2
            this.selectObj.is_multi = 1
            this.selectObj.photo_type = ''
            this.selectObj.type = ''
          }
          if (this.twoGradeIndex == 1) {
            this.selectObj.only_audio = 1
            this.selectObj.is_multi = 1
            this.selectObj.photo_type = ''
            this.selectObj.type = ''
          }
        }
        this.getWorksList()
      },
      handleTitle2(val) {
        this.twoGradeIndex = val
        this.firstEntry = true
        if (this.oneGradeIndex == 0) {
          if (val == 0) {
            this.workList = []
            this.selectObj.only_audio = ''
            this.selectObj.is_multi = ''
            this.selectObj.photo_type = ''
            this.selectObj.type = ''
            this.getWorksList()
          }
          // 宠物视频
          if (val == 1) {
            this.workList = []
            this.selectObj.photo_type = '2'
            this.selectObj.type = ''
            this.getWorksList()
          }
          // 照片说话
          if (val == 2) {
            this.workList = []
            this.selectObj.photo_type = '1'
            this.selectObj.type = ''
            this.getWorksList()
          }
          // 出海视频
          if (val == 3) {
            // this.getVideoTranslateList()
            this.workList = []
            this.selectObj.only_audio = ''
            this.selectObj.is_multi = ''
            this.selectObj.photo_type = ''
            this.selectObj.type = 'fy'
            this.getWorksList()

          }
        }
        if (this.oneGradeIndex == 1) {
          if (val == 0) {
            this.selectObj.only_audio = 2
            this.selectObj.is_multi = 1
            this.selectObj.photo_type = ''
            this.selectObj.type = ''
          }
          if (val == 1) {
            this.selectObj.only_audio = 1
            this.selectObj.is_multi = 1
            this.selectObj.photo_type = ''
            this.selectObj.type = ''
          }
          this.workList = []
          this.getWorksList()
        }
      },
      handlePlay(item) {
        if (item.status !== 3) {
          return false
        }
        this.videoName = item.name
        this.videoUrl = item.url
        this.dialogVisible = true
      },
      handleDown(item) {
        const url = item.url;
        const filename = item.name + '.mp3';
        const element = document.createElement('a');
        element.href = url;
        element.download = filename;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      },
      handleReName(item) {
        this.dialogVisible3 = true
        this.myOneVoice = item
      },
      sumbitName() {
        if (this.myOneVoice.id) {
          if (!this.name) {
            this.$message.error('请填写名称后保存')
          } else {
            postWorks({id: this.myOneVoice.id, name: this.name}).then(res => {
              this.dialogVisible3 = false
              this.name = ''
              this.myOneVoice = {}
              this.getWorksList()
            }).catch(error => {
              this.$message.error(error.msg)
            })
          }
        }
      },
      handleDialogClose() {
        // 停止视频播放
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
        }
      },
      handleDelete(item) {
        this.$confirm('此操作将永久删除该作品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.twoGradeIndex == 3) {
            delVideoTranslate({id: item.id}).then(() => {
              this.getWorksList()
            })
          } else {
            delWorks({id: item.id}).then(() => {
              this.getWorksList()
            })
          }
          this.getWorksTotal()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      updateProgress() {
        const video = this.$refs.videoPlayer;
        this.progress = (video.currentTime / video.duration) * 100;
      },
      // 下载视频
      downVideo(item) {
        const that = this
        var xhr = new XMLHttpRequest()
        xhr.open('GET', item.url, true)
        // xhr.open('GET', require('../../assets/images/test.mp4'), true)
        xhr.responseType = 'blob' // 返回类型blob
        // 监听进度
        that.dialogVisible4 = true
        that.progress = 0
        xhr.onprogress = function (e) {
          // console.log('e',e)
          if (e.lengthComputable) {
            // 文件总体积
            // console.log(e.total)
            // 已下载体积
            // console.log(e.loaded)
            var percentComplete = 0
            var percentComplete = e.loaded / e.total * 100;
            // console.log('percentComplete', percentComplete)
            that.progress = Math.floor(percentComplete)
          }
        }
        xhr.onload = function () {
          // this.show = false
          if (xhr.readyState === 4 && xhr.status === 200) {
            console.log('开始下载')
            // that.$message.success('开始下载，稍候在下载文件中查找！')
            const blob = this.response
            // console.log('blob',blob)
            // 转换一个blob链接
            const u = window.URL.createObjectURL(new Blob([blob]))
            const a = document.createElement('a')
            // a.download = '1344.mp4'
            var str = ''
            // str = new Date().getTime() + '.mp4'
            str = item.name + '.mp4'
            a.download = str
            a.href = u
            // console.log('下载名取好')
            // a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            // a.remove();
            // 释放
            console.log('结束')
            that.dialogVisible4 = false
            that.$message.success('下载成功！')
            window.URL.revokeObjectURL(u)
          } else {
            console.log('失败了')
            that.dialogVisible4 = false
            that.$message.error('下载失败！')
          }
        }
        xhr.onerror = function () {
          console.log('下载失败')
          that.dialogVisible4 = false
          that.$message.error('下载失败！')
        }
        xhr.send()
      },

    },
  }
</script>

<style scoped lang="scss">
  p {
    margin: 0;
    padding: 0;
  }

  .no-fenshen-box {
    margin-top: 30vh;

    img {
      width: 48px;
      height: 48px;
    }

    p {
      margin: 24px auto 28px;
    }

    font-weight: 400;
    font-size: 16px;
    color: #FAFAFA;
    text-align: center;

    .ks-dingzhi {
      width: 156px;
      height: 48px;
      background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
      border-radius: 6px;

      font-weight: 600;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 48px;
      text-align: center;
      margin: 0 auto;
    }
  }

  .home-box {
    font-size: 18px;
    cursor: pointer;
    /*padding: 0 24px 24px 24px;*/
    height: calc(100vh - 50px);

    .dz-btn-box {
      width: 144px;
      height: 40px;
      background: #6C14FF;
      border-radius: 6px;

      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
      margin-left: 15px;
    }

    .my-works {
      /*height: 850px;*/
      height: 100%;
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */

      .select-box {
        width: 100%;
        position: sticky;
        top: 0;
        z-index: 999;
        height: 110px;

        .one-grade {
          height: 70px;
          border-bottom: 1px solid #393C4E;
          border-left: 1px solid #393C4E;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #FAFAFAAA;
          line-height: 70px;
          padding: 0 26px;
        }

        .two-grade {
          padding: 24px;
          border-left: 1px solid #393C4E;

          .every-fl-box {
            height: 32px;
            background: #1F192F;
            border-radius: 6px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            padding: 0 12px;
            font-weight: 400;
            font-size: 14px;
            color: #FAFAFAAA;
            line-height: 32px;
            text-align: center;
            margin-right: 16px;
          }

          .active-fl {
            background: #6C14FF;
            border: 1px solid rgba(255, 255, 255, 0.2);
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
      .works-info-box::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      .works-info-box {
        padding: 0 24px 24px 24px;

        height: calc(100vh - 220px);
        overflow-y: scroll;
        overflow-x: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
      }

      .mr15 {
        margin-right: 15px;
      }

      .every-video {
        width: 243px;
        height: 432px;
        border-radius: 16px;
        padding: 10px;
        border: 1px solid #f5f5f5;
        position: relative;
        margin-bottom: 45px;
        margin-right: 30px;
        /*background-size: 100% 100%;*/
        background-size: contain;
        background-position: center;

        .api-num1, .api-num2, .api-num3, .api-num-other {
          position: absolute;
          top: 8px;
          right: 8px;
          z-index: 9;
          width: 57px;
          height: 20px;
          background: #959494;
          border-radius: 4px;
          /*opacity: 0.3;*/
          font-weight: 400;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 20px;
          text-align: center;
        }

        .api-num2 {
          background: #EADDAD;
          opacity: 0.9;
          color: #604E10;
        }

        .api-num3 {
          background: #3AFAF5;
          opacity: 0.9;
          color: #26415A;
        }

        .api-num-other {
          background: #6C14FF;
          opacity: 0.9;
          color: #E3D8F7;
        }

        .desc-box {
          width: 243px;
          height: 64px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 0px 0px 16px 16px;
          position: absolute;
          bottom: -1px;
          left: -1px;
          padding: 12px 16px;

          .left-tt-box {
            width: 207px;

            .text11 {
              width: 185px;
              font-weight: 500;
              font-size: 14px;
              color: #FAFAFA;
              text-align: left;
              margin-bottom: 4px;
            }

            .text22 {
              font-weight: 400;
              font-size: 12px;
              color: #FAFAFAAA;
              text-align: left;
            }
          }

          .handle-box-img {
            width: 24px;
            height: 24px;
          }

        }

        .shengchenging {
          z-index: 9;
          position: absolute;
          width: 100%;
          height: calc(100% - 64px);
          border-radius: 16px 16px 0 0;
          top: 0;
          left: 0;
          background: rgba(42, 41, 41, 0.7);
          /*background: url('../assets/images/shengchengBg.jpg') no-repeat;*/
          /*background-size: 100% 100%;*/
          text-align: center;
          font-size: 14px;

          .desc-pp {
            padding-top: 200px;
          }

          img {
            /*padding-top: 280px;*/
            width: 100%;
            /*height: 40px;*/
          }

          .pt150 {
            padding-top: 120px;
          }
        }
      }

      .every-video:nth-child(6n) {
        margin-right: 0 !important;
      }


      .every-voice {
        margin-right: 25px;
        margin-bottom: 25px;
        cursor: pointer;
        position: relative;
        width: 392px;
        display: flex;
        padding: 8px;
        /*background: #24273C;*/
        border: 1px solid;
        /*border: 1px solid #e2e6ff;*/
        border-radius: 6px;
        gap: 12px;
        height: 82px;

        .type1-tips, .type2-tips {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 52px;
          height: 20px;
          background: #2550F6;
          border-radius: 4px;

          font-weight: 400;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 20px;
          text-align: center;
        }

        .type2-tips {
          background: #7BBF00;
        }

        .card-img {
          position: relative;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          margin-right: 16px;

          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
            border-radius: 50%;
            /*border-radius: 8px;*/
          }

          .hover-box {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border-radius: 50%;
            text-align: center;
            background: rgba(0, 0, 0, .5);
            cursor: pointer;
            justify-content: center;
            align-items: center;

            .play-pause-btn {
              margin-top: 10px;

              .playing-box {
                width: 30px;
                height: 18px;
              }
            }
          }
        }

        .pp4 {
          font-size: 14px;
          color: #fff;
          line-height: 24px;
          font-weight: 500;
          margin-bottom: 5px;
        }

        .pp5 {
          font-size: 12px;
          font-weight: 400;
          color: #aaaab5;
        }

        .all-tags {
          .every-tag {
            font-size: 12px;
            color: #5b647a;
            letter-spacing: 0;
            text-align: center;
            line-height: 20px;
            font-weight: 400;
            background: #edeef7;
            border-radius: 4px;
            padding: 0 4px;
            white-space: nowrap;
            margin-right: 5px;
          }
        }

        .handle-box {
          position: absolute;
          top: 3px;
          right: 10px;
        }
      }
    }
    .my-works::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
  }

  .dialog-video {
    width: 100%;
    height: 440px;
  }
</style>
<style>
  .my-works .el-input {
    width: 200px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/works.vue